import { render, staticRenderFns } from "./NvRadio.vue?vue&type=template&id=75500230&scoped=true&"
import script from "./NvRadio.ts?vue&type=script&lang=ts&"
export * from "./NvRadio.ts?vue&type=script&lang=ts&"
import style0 from "./NvRadio.vue?vue&type=style&index=0&id=75500230&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75500230",
  null
  
)

export default component.exports